let openCount = 0;
let scrollPosition = 0;
let scrollBarWidth = 0;
let restoreFrame = 0;
let restoreTimeout = 0;

function getScrollPosition() {
  const scrollingElement = document.scrollingElement || document.documentElement;
  return (
    window.pageYOffset ||
    scrollingElement.scrollTop ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  );
}

function restoreScrollPosition(savedScroll) {
  const top = Math.max(0, savedScroll);
  const scrollingElement = document.scrollingElement || document.documentElement;

  scrollingElement.scrollTop = top;
  document.documentElement.scrollTop = top;
  if (document.body) {
    document.body.scrollTop = top;
  }

  if (typeof window.scrollTo === 'function') {
    try {
      window.scrollTo({ top, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, top);
    }
  }
}

function scheduleScrollRestore(savedScroll) {
  if (restoreFrame) {
    cancelAnimationFrame(restoreFrame);
  }
  if (restoreTimeout) {
    clearTimeout(restoreTimeout);
  }

  restoreScrollPosition(savedScroll);

  restoreFrame = requestAnimationFrame(() => {
    restoreScrollPosition(savedScroll);
    restoreFrame = requestAnimationFrame(() => {
      restoreScrollPosition(savedScroll);
      restoreFrame = 0;
    });
  });

  restoreTimeout = window.setTimeout(() => {
    if (Math.abs(getScrollPosition() - savedScroll) > 2) {
      restoreScrollPosition(savedScroll);
    }
    restoreTimeout = 0;
  }, 0);

  window.setTimeout(() => {
    if (Math.abs(getScrollPosition() - savedScroll) > 2) {
      restoreScrollPosition(savedScroll);
    }
  }, 50);
}

export function lockScroll() {
  openCount += 1;
  if (openCount !== 1) return;

  scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  scrollPosition = getScrollPosition();

  document.documentElement.setAttribute('scroll-lock', '');

  if (scrollBarWidth > 0) {
    document.body.style.paddingRight = `${scrollBarWidth}px`;
  }
}

export function unlockScroll() {
  if (openCount <= 0) {
    openCount = 0;
    return;
  }

  openCount -= 1;
  if (openCount !== 0) return;

  const savedScroll = scrollPosition;

  document.documentElement.removeAttribute('scroll-lock');
  document.body.style.paddingRight = '';

  scheduleScrollRestore(savedScroll);
}

export function isScrollLocked() {
  return openCount > 0;
}

export function recalculateScrollLockPadding() {
  if (!document.documentElement.hasAttribute('scroll-lock')) return;

  const nextScrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  if (nextScrollBarWidth === scrollBarWidth) return;

  scrollBarWidth = nextScrollBarWidth;
  document.body.style.paddingRight = scrollBarWidth > 0 ? `${scrollBarWidth}px` : '';
}

function handleResize() {
  recalculateScrollLockPadding();
}

function preventFocusScrollAfterDialogClose(event) {
  if (!(event.target instanceof HTMLDialogElement)) return;
  if (!event.target.hasAttribute('scroll-lock')) return;

  const fixFocusScroll = () => {
    const activeElement = document.activeElement;
    if (!(activeElement instanceof HTMLElement)) return;

    try {
      activeElement.focus({ preventScroll: true });
    } catch {
      activeElement.blur();
    }
  };

  requestAnimationFrame(() => {
    fixFocusScroll();
    requestAnimationFrame(() => {
      fixFocusScroll();
      if (openCount === 0) {
        scheduleScrollRestore(scrollPosition);
      }
    });
  });
}

window.addEventListener('resize', handleResize);
window.addEventListener('orientationchange', handleResize);
document.addEventListener('close', preventFocusScrollAfterDialogClose, true);

if (typeof window !== 'undefined') {
  window.themeScrollLock = {
    lock: lockScroll,
    unlock: unlockScroll,
    isLocked: isScrollLocked,
  };
}
